export default __webpack_public_path__ + "static/media/man-big.3a37fade.png";